import { render, staticRenderFns } from "./shipping.vue?vue&type=template&id=681bbc9b&scoped=true"
import script from "./shipping.vue?vue&type=script&lang=js"
export * from "./shipping.vue?vue&type=script&lang=js"
import style0 from "./shipping.vue?vue&type=style&index=0&id=681bbc9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681bbc9b",
  null
  
)

export default component.exports